<script setup lang="ts">
import CommonHeader from "@/components/Menu/index.vue";
import type { NavigationItem } from "@/components/Menu/type";

import { useNavigation } from "@/hook/useNavigation";

const { mainMenuItems } = useNavigation();

const router = useRouter();

const handleMenuClick = (item: NavigationItem) => {
  console.log("菜单点击:", item);
};

const handleMenuToggle = (params: any) => {
  console.log("菜单切换:", params);
};

const handleLogoClick = () => {
  console.log("Logo 点击");
  router.push({ name: "/" });
};
</script>

<template>
  <!-- 或使用自定义配置 -->
  <CommonHeader
    :main-menu-items="mainMenuItems"
    :show-english="true"
    :show-login="true"
    logo-text="I C A A"
    @menu-click="handleMenuClick"
    @toggle="handleMenuToggle"
    @logo-click="handleLogoClick"
  />
</template>
